import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyle } from './PrequalStyle.js';
import { changeAddress, ChangePhonenumber } from './Constants';
import { useLocalStorage, usePrequalSessionCookie, usePrequalCookie } from './EirPrequalPersistance';
import { getSpeed, getContext } from './EirPrequalUtil.js';
import PubSub from 'pubsub-js';

export default function EirPrequalForm(props) {
    const { getLocalStorage, clearLocalStorage, setLocalStorage } = useLocalStorage();
    const [fontColor, setFontColor] = useState('');
    const [prequaled_by, setPrequaled_by] = useState('Eircode');
    const [speed, setSpeed] = useState('');
    const { setCookie } = usePrequalCookie();
    //const [changeBackGroundColor, setChangeBackGroundColor] = useState(true);
    const [isTvEligible, setIsTvEligible] = useState(true);
    const classes = useStyle();
    let context = getContext();
    const setDataLayer = (title, url) => {
        dataLayer.push({
            event: 'VirtualPageview',
            virtualPageURL: url,
            virtualPageTitle: title,
        });
    };
    useEffect(() => {
        if (!fontColor) setFontColor(props.prop.resources.resources.textFontColorPostPrequal);

        if (getLocalStorage('eir_prequal_data')) {
            setPrequaled_by(getLocalStorage('prequaled_By'));

            let Speed = getSpeed(); //getting line speed, after prequal

            if (Speed.error === 'Line unknown') {
                //if there is error in prequal, will show the alternate page
                if (getLocalStorage('prequaled_By') === 'Phone') {
                    //here we will call the we are sorry page(after phone number)
                    setLocalStorage('phone', {
                        areaCode: getLocalStorage('eir_prequal_data').areaCode,
                        number: getLocalStorage('eir_prequal_data').number,
                    });
                    if (getLocalStorage('currentContext')) {
                        let prequalContext = getLocalStorage('currentContext');
                        window.open(`/${prequalContext}noresult/`, '_self');
                    }
                } else if (getLocalStorage('prequaled_By') === 'Eircode') {
                    //phone number form will be show with different title and subtitle
                    props.setPrequalData(getLocalStorage('eir_prequal_data').eircode);
                    props.makePhoneNumberVisible();
                    props.controlIfPrequalByEircodeFailed(true);
                }
                clearLocalStorage('eir_prequal_data');
                clearLocalStorage('eir_prequal_result');
            } else {
                setSpeed(Speed.finalspeed);
                props.controlIfPrequalByEircodeFailed(false);
                PubSub.publish('PREQUAL_SUCCESS');
                setTimeout(() => {
                    let cont;
                    if (getLocalStorage('currentContext')) {
                        cont = getLocalStorage('currentContext');
                        if (cont.slice(-1) !== '/') cont = cont + '/';
                    }
                    window.history.pushState({}, '', window.location.origin + `/${cont}results/`);
                    setDataLayer(`Post-Prequal| eir.ie`, `/${cont}results/`);
                }, 0);
            }
        }
    }, []);

    useEffect(() => {
        if (getLocalStorage('eir_prequal_data')) {
            const prequalData = getLocalStorage('eir_prequal_data')
            if(prequalData.inbi){
                setIsTvEligible(false);
            }else{
                setIsTvEligible(prequalData.itv);
            }
            
        }
    }, []);

    //Added useeffect to show address and phone number accordingly in customisebundles page
    useEffect(() => {
        if(getLocalStorage('prequaled_By') === 'Phone'){
            setLocalStorage('ls_prequalby','phone');
            setCookie('eir_prequal_user_location_type','number');
        }
        else{
            setLocalStorage('ls_prequalby','eircode');
            setCookie('eir_prequal_user_location_type','address');
        }
    }, []);

    //if any, Change Address or Change Phone Number is clicked, alternate form will be shown
    const handleChangeAddressClick = () => {
        // if (getLocalStorage('prequaled_By') === 'Phone') {
        //     props.controlIfPrequalByEircodeFailed(false);
        //     props.makePhoneNumberVisible();
        // } else if (getLocalStorage('prequaled_By') === 'Eircode') {
        //     props.controlIfPrequalByEircodeFailed(false);
        //     props.makeEircodeVisible();
        // }
        window.location.href = '/shop/broadband';
        localStorage.clear();     
    };
    return (
        <React.Fragment>
            <div
                className={classes.PrequalBackGround}
                style={{
                    background: `url(${props.prop.resources.resources.backgroundImagePostPrequal.path}) center top/100% 100% no-repeat`,
                }}>
                <div className={classes.PrequalContainer}>
                    <Grid className={classes.PrequalLeftPart}>
                        {context == 'tv' ? (
                            isTvEligible ? (
                                <Typography
                                    className={classes.PrequalHeadingText}
                                    style={{ color: fontColor }}
                                    variant={props.prop.resources.useH1 ? 'h1' : 'body1'}>
                                    {`${props.prop.resources.resources.titlePostPrequalPrefix} ${speed} ${props.prop.resources.resources.titlePostPrequalSuffix}`}
                                </Typography>
                            ) : (
                                <Typography
                                    className={classes.PrequalHeadingText}
                                    style={{ color: fontColor }}
                                    variant={props.prop.resources.useH1 ? 'h1' : 'body1'}>
                                    {`${props.prop.resources.resources.titlePostPrequalTvNotEligiblePrefix} ${speed} ${props.prop.resources.resources.titlePostPrequalTvNotEligibleSuffix}`}
                                </Typography>
                            )
                        ) : (
                            <Typography
                                className={classes.PrequalHeadingText}
                                style={{ color: fontColor }}
                                variant={props.prop.resources.useH1 ? 'h1' : 'body1'}>
                                {`${props.prop.resources.resources.titlePostPrequalPrefix} ${speed} ${props.prop.resources.resources.titlePostPrequalSuffix}`}
                            </Typography>
                        )}

                        <div className={classes.AfterPrequalParagraph}>
                            {prequaled_by === 'Eircode' ? (
                                <React.Fragment>
                                    <Typography
                                        className={classes.ParagraphText}
                                        style={{ color: fontColor }}>
                                        {getLocalStorage('eir_prequal_data').fullAddress},{' '}
                                        {getLocalStorage('eir_prequal_data').eircode}
                                    </Typography>

                                    <Typography
                                        className={classes.ChangeAddressText}
                                        style={{ color: fontColor }}
                                        onClick={handleChangeAddressClick}>
                                        {`${changeAddress}`}
                                    </Typography>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <Typography
                                        className={classes.ParagraphText}
                                        style={{ color: fontColor }}>
                                        <span className={classes.NotBoldParagraphText}>
                                            Number:
                                        </span>{' '}
                                        {getLocalStorage('eir_prequal_data').areaCode}{' '}
                                        {getLocalStorage('eir_prequal_data').number}
                                    </Typography>

                                    <Typography
                                        className={classes.ChangeAddressText}
                                        style={{ color: fontColor }}
                                        onClick={handleChangeAddressClick}>
                                        {`${ChangePhonenumber}`}
                                    </Typography>
                                </React.Fragment>
                            )}
                        </div>
                    </Grid>
                    <Grid className={classes.PrequalRightPart}>
                        <picture>
                            <source
                                media='(max-width: 1019px)'
                                srcSet={props.prop.resources.resources.bannerImageMobilePostPrequal.path}
                            />
                            <img
                                className={classes.PrequalBanner}
                                src={props.prop.resources.resources.bannerImageDesktopPostPrequal.path}
                                onError={event => {
                                    event.target.style.display = 'none';
                                }}
                                onLoad={event => {
                                    event.target.style.display = 'inline-block';
                                }}
                            />
                        </picture>
                    </Grid>
                </div>
            </div>
        </React.Fragment>
    );
}
